import { render, staticRenderFns } from "./FavoriteReports.vue?vue&type=template&id=74e2a006"
import script from "./FavoriteReports.vue?vue&type=script&lang=js"
export * from "./FavoriteReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports